import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectsService} from '../_services/projects.service';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {SingleProjectModel} from '../_models/singleProject.model';

@Component({
    selector: 'app-stage-edit',
    templateUrl: './stage-edit.component.html',
    styleUrls: ['./stage-edit.component.scss']
})
export class StageEditComponent implements OnInit, OnDestroy {
    dataLoaded = false;

    projectId: string;
    stageId: string;
    stageData: any;

    editStageForm: FormGroup;
    colorsClasses = ['stage-red', 'stage-blue', 'stage-yellow', 'stage-green', 'stage-orange'];

    // Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg = '';
    errorMsg = '';

    // Unsubscribe
    unsubscribe = [];

    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: NgbModal,
                private projectsService: ProjectsService,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {
        const routeSub = this.route.params.subscribe(params => {
            this.projectId = params.id;
            this.stageId = params.position;
            
        });
        this.unsubscribe.push(routeSub);
        this.projectsService.getProjectById(this.projectId).subscribe((project: SingleProjectModel) => {
            
            this.stageData = project.stage[Number(this.stageId) - 1];
            
            this.loadStageForm();
            this.dataLoaded = true;
        });
    }

    // Custom validator
    checkDateDifference(control: AbstractControl): ValidatorFn {

        // Set form value in variables
        const startDate = control.get('startDate').value;
        const endDate = control.get('endDate').value;

        // If Start Date is bigger then End Date, then throw error
        if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
            control.get('startDate').setErrors({startDateIsBiggerThanEndDate: true});
        } else {
            control.get('startDate').setErrors(null);
        }
        return;
    }

    loadStageForm() {
        this.editStageForm = this.fb.group({
            name: [this.stageData.name, Validators.required],
            color: [this.stageData.color],
            startDate: [this.stageData.startDate, Validators.required],
            endDate: [this.stageData.deadLine, Validators.required],
            description: [this.stageData.observation]
        }, {validators: this.checkDateDifference});
    }

    submitStageForm() {
        const formToSend = {
            name: this.editStageForm.value.name,
            color: this.editStageForm.value.color,
            startDate: this.editStageForm.value.startDate,
            deadLine: this.editStageForm.value.endDate,
            observation: this.editStageForm.value.description,
            stageTasks: this.stageData.stageTasks,
            status: this.stageData.status,
            responsible: this.stageData.responsible
        };

        this.editStageForm.markAllAsTouched();
        if (this.editStageForm.valid) {
            const sub = this.projectsService
                .updateProjectStage(this.projectId, Number(this.stageId), formToSend)
                .subscribe(res => {
                    
                    this.router.navigate([`/projects/${this.projectId}/stage/${this.stageId}/view`]);
                }, error => {
                    
                    this.feedbackMsg('error', 'Something went wrong');
                });

            this.unsubscribe.push(sub);
        } else {
            this.scrollToTop();
            this.feedbackMsg('error', 'Please fill out the required fields.');
        }
    }

    // Scroll Top
    scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.editStageForm.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }


    controlHasError(validation: string, controlName: string) {
        const control = this.editStageForm.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }


    ngOnDestroy() {
        this.unsubscribe.forEach(sb => sb.unsubscribe());
    }


}
